/**
 * UYAP bağlantı kurtarma: yeniden bağlanma temposu ve kota-dolu bildirimi.
 *
 * Oturum düştüğünde görev HATAYA DÜŞÜRÜLMEZ; bot kaldığı yerde durup bağlanmayı
 * dener. Denemeler giderek uzayan aralıklarla yapılır (login-spam ban'ını önlemek
 * için) ve ASLA vazgeçilmez. Bağlantı gelince askıdaki istek kaldığı yerden çalışır.
 *
 * Saf tutulur (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

/**
 * Yeniden bağlanma denemeleri arası bekleme (ms). Son değer TAVANDIR; denemeler
 * sonsuza dek bu aralıkla sürer. İlk denemeler kısa (geçici kopmalar hızlı toparlansın),
 * sonrakiler uzun (ban riski olmasın).
 */
export const YENIDEN_BAGLANMA_BEKLEMELERI_MS = [15_000, 30_000, 60_000, 120_000];

/** deneme 1'den başlar; dizinin dışına taşınca son (tavan) değeri döner. */
export function yenidenBaglanmaBeklemesiMs(deneme: number): number {
    const i = Math.min(Math.max(deneme - 1, 0), YENIDEN_BAGLANMA_BEKLEMELERI_MS.length - 1);
    return YENIDEN_BAGLANMA_BEKLEMELERI_MS[i];
}

/** UYAP kota dolu hatasının metni (PRTL_GNL_100026-1). */
export const KOTA_DOLU_MESAJI = 'En fazla 5 aktif oturum açabilirsiniz!';

export function kotaDoluHatasiMi(hata: any): boolean {
    const mesaj = String(hata?.message ?? hata ?? '');
    return mesaj.includes(KOTA_DOLU_MESAJI.trim()) || hata?.errorCode === 'PRTL_GNL_100026-1';
}

/**
 * Kota dolduğunda çağrılacak kanca (dialog + işletim sistemi bildirimi + ses).
 * Uygulama kaydeder; kaydedilmezse sessizce atlanır — böylece bu modül store/DOM'a
 * bağlanmaz ve uyap-plugin'i kullanan diğer uygulamalarda da sorunsuz çalışır.
 */
let kotaKancasi: (() => void) | null = null;

export function kotaUyarisiKancasiniAyarla(fn: (() => void) | null): void {
    kotaKancasi = fn;
}

export function kotaUyarisiGoster(): void {
    if (!kotaKancasi) {
        return;
    }
    try {
        kotaKancasi();
    } catch (e) {
        console.warn('Kota uyarısı gösterilemedi:', e);
    }
}
